import { getI18n } from 'react-i18next';

export const VALIDATION_FILE_UPLOAD_FILE_TOO_LARGE = 'validation.fileUpload.fileTooLarge';
export const ERROR_FILE_UPLOAD_EXTERNAL_UNKNOWN_ERROR = 'error.fileUpload.externalUnknownError';
export const ERROR_FILE_UPLOAD_CANNOT_PROCESS_FILE = 'error.fileUpload.cannotProcessFile';
export const ERROR_FILE_UPLOAD_FILE_TOO_LARGE = 'error.fileUpload.fileTooLarge';
export const ERROR_FILE_UPLOAD_UNKNOWN_ERROR = 'error.fileUpload.unknownError';

export const createUploadErrorMessage = (code, params) => { // NOSONAR javascript:S3800
    let result;
    const i18n = getI18n();
    switch (code) {
        case VALIDATION_FILE_UPLOAD_FILE_TOO_LARGE:
            result = i18n.t('file-upload.validation.file-too-large', params);
            break;
        case ERROR_FILE_UPLOAD_EXTERNAL_UNKNOWN_ERROR:
            result = i18n.t('file-upload.error.external-unknown-error', params);
            break;
        case ERROR_FILE_UPLOAD_CANNOT_PROCESS_FILE:
            result = i18n.t('file-upload.error.cannot-process-file');
            break;
        case ERROR_FILE_UPLOAD_FILE_TOO_LARGE:
            result = i18n.t('file-upload.error.file-too-large', params);
            break;
        case ERROR_FILE_UPLOAD_UNKNOWN_ERROR:
            result = i18n.t('file-upload.error.unknown-error');
            break;
        default:
            result = undefined;
    }
    return result;
};
